import { combineReducers } from 'redux';

import mapview from 'reducers/mapview/index';

export default combineReducers({
  mapview,
});
